export default __webpack_public_path__ + "locales/sr-Latn-RS/VersionHistory.json?hash=0811cba745295adb6fd4feb6ea53ee9b";